var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSlider3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 548,
    height: 436,
    fill: "none",
    viewBox: "0 0 548 436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M423.805 355.564c-8.009 8.221-15.587 13.523-21.574 17.712-70.379 49.239-153.655 34.886-171.354 31.381-26.135-5.176-76.655-15.181-113.179-57.062-55.258-63.364-46.654-163.19-3.792-229.088 7.84-12.053 49.254-78.954 133.428-89.683 50.941-6.493 110.322 6.603 153.324 41.732 90.265 73.739 83.839 222.706 23.147 285.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "M149.719 25.918c-12.603 34.664-79.164 237.81 68.341 297.003 0 0 72.485-129.231-63.785-298.778-1.192-1.483-3.732-.49-4.556 1.775Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M157.5 57.372s-.245 4.112-.438 11.326a699.511 699.511 0 0 0-.138 29.895 738.51 738.51 0 0 0 1.873 42.218c1.151 15.417 2.879 31.829 5.432 48.117a476.212 476.212 0 0 0 4.396 24.194 382.513 382.513 0 0 0 5.605 23.136c2.058 7.44 4.303 14.559 6.686 21.216 2.382 6.657 4.904 12.851 7.464 18.458 2.563 5.606 5.14 10.638 7.621 14.982.611 1.091 1.249 2.12 1.839 3.128l.878 1.479.887 1.397 1.67 2.625 1.596 2.34c.993 1.495 1.955 2.774 2.78 3.896l1.146 1.554.997 1.259 1.828 2.307.022.028a.94.94 0 0 1-1.474 1.168l-.003-.003-1.846-2.35-1.007-1.282-1.155-1.58c-.832-1.142-1.802-2.443-2.801-3.961l-1.607-2.377-1.68-2.663-.891-1.417-.883-1.5c-.592-1.021-1.233-2.065-1.846-3.17-2.489-4.401-5.07-9.49-7.63-15.152-2.558-5.664-5.072-11.912-7.44-18.62-2.371-6.707-4.598-13.873-6.634-21.355-2.038-7.482-3.888-15.28-5.532-23.25a477.715 477.715 0 0 1-4.31-24.284c-2.492-16.339-4.156-32.791-5.245-48.238a737.748 737.748 0 0 1-1.702-42.287c-.298-24.777.746-41.282.746-41.282a.398.398 0 0 1 .796.048Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4174FF",
    d: "M181.99 252.379S63.458 210.62 81.863 60.765c.307-2.499 4.25-3.88 6.504-2.28 20.981 14.887 92.821 74.542 93.623 193.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m102.601 90.871 10.646 22.201a3657.244 3657.244 0 0 1 10.799 22.809l5.969 12.923 3.048 6.654 3.024 6.729 5.998 13.416 5.758 13.02 5.268 12.226c1.674 3.887 3.213 7.582 4.656 10.982a265.758 265.758 0 0 1 2.032 4.896l1.807 4.427 1.588 3.893 1.315 3.319 2.474 6.305a.35.35 0 0 1-.648.267l-.002-.005-2.664-6.221-1.393-3.283-1.679-3.85-4.04-9.229c-1.493-3.376-3.084-7.044-4.814-10.904l-5.444-12.14-5.822-12.983-6.063-13.38-11.951-26.335-10.355-23.008-7.367-16.254-2.074-4.55a4390.34 4390.34 0 0 0-.744-1.605.374.374 0 0 1 .678-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "m99.842 145.855 338.284-5.716c13.619-.23 24.551 11.451 23.741 25.37l-11.643 200.24c-.638 10.959-9.452 19.543-20.177 19.649l-325.172 3.216c-8.032.08-14.668-6.396-14.974-14.612l-7.78-208.988c-.385-10.343 7.612-18.988 17.72-19.159Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "m105.028 150.957 329.454-5.439c13.264-.219 23.911 10.894 23.122 24.137l-11.34 190.509c-.62 10.426-9.205 18.594-19.649 18.695l-316.686 3.059c-7.822.076-14.285-6.086-14.583-13.902L87.77 169.184c-.375-9.84 7.413-18.065 17.259-18.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "m111.655 161.183 314.692-5.097c12.669-.205 22.839 10.209 22.086 22.618l-10.832 178.517c-.593 9.77-8.793 17.423-18.769 17.518l-302.495 2.867c-7.471.071-13.645-5.703-13.929-13.028l-7.237-186.316c-.359-9.22 7.08-16.927 16.484-17.079Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "m204.537 186.979-92.257.243a.35.35 0 0 1-.349-.348l-.019-7.5a.348.348 0 0 1 .347-.349l92.256-.243c.192 0 .349.155.349.347l.02 7.501a.349.349 0 0 1-.347.349Zm58.199.025-31.947.084a.334.334 0 0 1-.335-.333l-.02-7.529c0-.184.149-.334.333-.335l31.948-.084c.184 0 .334.149.335.333l.019 7.529a.334.334 0 0 1-.333.335Zm70.939-.187-63.353.167a.531.531 0 0 1-.532-.53l-.019-7.134a.53.53 0 0 1 .53-.533l63.352-.167c.293 0 .532.237.532.53l.019 7.134a.53.53 0 0 1-.529.533Zm-197.458 14.746-23.856.063a.53.53 0 0 1-.532-.529l-.019-7.135a.53.53 0 0 1 .53-.532l23.855-.063a.532.532 0 0 1 .533.53l.019 7.134a.531.531 0 0 1-.53.532Zm68.542-.165-66.904.176a.349.349 0 0 1-.349-.347l-.02-7.501a.35.35 0 0 1 .348-.349l66.903-.176c.192 0 .349.155.349.348l.02 7.5a.349.349 0 0 1-.347.349Zm58.277.024-31.947.085a.334.334 0 0 1-.335-.334l-.02-7.528a.335.335 0 0 1 .333-.335l31.947-.084c.185 0 .335.149.335.333l.02 7.529a.332.332 0 0 1-.333.334Zm123.414-.324-93.302.245a.53.53 0 0 1-.532-.529l-.019-7.135a.531.531 0 0 1 .53-.532l93.301-.246c.294 0 .532.237.533.53l.018 7.134a.531.531 0 0 1-.529.533Zm-250.214 14.864-23.855.063a.53.53 0 0 1-.533-.53l-.018-7.134a.53.53 0 0 1 .529-.532l23.856-.063a.53.53 0 0 1 .532.529l.019 7.135a.53.53 0 0 1-.53.532Zm68.528-.166-66.903.177a.35.35 0 0 1-.35-.348l-.019-7.5a.348.348 0 0 1 .347-.349l66.904-.176a.348.348 0 0 1 .349.347l.019 7.5a.347.347 0 0 1-.347.349Zm58.286.025-31.947.084a.333.333 0 0 1-.335-.333l-.02-7.528c0-.185.149-.335.333-.335l31.948-.084a.334.334 0 0 1 .335.333l.019 7.528a.333.333 0 0 1-.333.335Zm163.583-.431-121.9.321a.53.53 0 0 1-.532-.529l-.019-7.135a.531.531 0 0 1 .53-.532l121.9-.321a.53.53 0 0 1 .532.53l.019 7.134a.53.53 0 0 1-.53.532Zm-290.158 14.991-23.856.063a.53.53 0 0 1-.532-.53l-.019-7.134a.53.53 0 0 1 .53-.532l23.855-.063a.53.53 0 0 1 .533.529l.018 7.135a.53.53 0 0 1-.529.532Zm68.683-.166-66.904.176a.348.348 0 0 1-.349-.347l-.02-7.5c0-.193.155-.349.348-.349l66.903-.176a.348.348 0 0 1 .349.347l.02 7.5a.348.348 0 0 1-.347.349Zm58.192.025-31.947.084a.334.334 0 0 1-.335-.333l-.02-7.529a.334.334 0 0 1 .333-.335l31.947-.084c.185 0 .335.149.335.334l.02 7.528a.335.335 0 0 1-.333.335Zm163.967-.432-121.899.321a.53.53 0 0 1-.533-.53l-.019-7.134c0-.293.237-.532.53-.532l121.9-.321a.53.53 0 0 1 .532.529l.019 7.135a.53.53 0 0 1-.53.532Zm-290.878 15.536-23.856.062a.531.531 0 0 1-.533-.529l-.018-7.134a.53.53 0 0 1 .529-.533l23.856-.063a.532.532 0 0 1 .533.53l.018 7.134a.531.531 0 0 1-.529.533Zm68.624-.166-66.904.176a.349.349 0 0 1-.349-.347l-.019-7.5a.348.348 0 0 1 .347-.35l66.903-.176c.193 0 .349.155.349.348l.02 7.5a.348.348 0 0 1-.347.349Zm58.227.024-31.947.084a.334.334 0 0 1-.335-.333l-.02-7.528c0-.184.149-.334.333-.335l31.948-.084c.184 0 .334.149.335.333l.02 7.529a.334.334 0 0 1-.334.334Zm163.823-.431-121.9.321a.532.532 0 0 1-.533-.53l-.018-7.134a.53.53 0 0 1 .529-.532l121.9-.321a.53.53 0 0 1 .533.529l.018 7.134a.53.53 0 0 1-.529.533Zm-290.436 14.991-23.856.063a.53.53 0 0 1-.532-.529l-.019-7.135a.53.53 0 0 1 .53-.532l23.855-.063a.53.53 0 0 1 .533.53l.019 7.134a.531.531 0 0 1-.53.532Zm68.779-.166-66.904.176a.348.348 0 0 1-.349-.347l-.019-7.5a.348.348 0 0 1 .347-.349l66.903-.176a.348.348 0 0 1 .35.347l.019 7.5a.347.347 0 0 1-.347.349Zm58.135.025-31.948.084a.334.334 0 0 1-.335-.333l-.019-7.528a.333.333 0 0 1 .333-.335l31.947-.084a.333.333 0 0 1 .335.333l.02 7.528a.334.334 0 0 1-.333.335Zm81.196-.214-74.273.196a.532.532 0 0 1-.533-.53l-.019-7.134c0-.293.237-.532.53-.533l74.273-.195a.531.531 0 0 1 .533.529l.018 7.135a.53.53 0 0 1-.529.532Zm-139.276 14.588-92.762.244a.347.347 0 0 1-.349-.347l-.02-7.5a.348.348 0 0 1 .347-.35l92.763-.244a.35.35 0 0 1 .349.348l.02 7.5a.35.35 0 0 1-.348.349Zm58.094.025-31.947.084a.334.334 0 0 1-.335-.333l-.02-7.529a.334.334 0 0 1 .333-.335l31.947-.084c.185 0 .335.149.335.334l.02 7.528a.335.335 0 0 1-.333.335Zm116.785-.308-92.86.245a.531.531 0 0 1-.532-.53l-.019-7.134a.53.53 0 0 1 .53-.533l92.86-.244a.53.53 0 0 1 .532.529l.019 7.135a.53.53 0 0 1-.53.532Zm-244.393 14.871-22.86.06a.53.53 0 0 1-.532-.53l-.019-7.134a.53.53 0 0 1 .53-.533l22.859-.06a.532.532 0 0 1 .533.53l.018 7.134a.531.531 0 0 1-.529.533Zm69.858-.169-66.904.176a.349.349 0 0 1-.349-.347l-.019-7.501a.348.348 0 0 1 .347-.349l66.903-.176c.193 0 .349.155.349.347l.02 7.5a.348.348 0 0 1-.347.35Zm58.05.025-31.948.084a.335.335 0 0 1-.335-.334l-.019-7.528a.334.334 0 0 1 .333-.335l31.947-.084c.185 0 .335.149.335.333l.02 7.529a.335.335 0 0 1-.333.335Zm164.132-.433-126.076.332a.53.53 0 0 1-.532-.529l-.019-7.135a.53.53 0 0 1 .529-.532l126.077-.332a.53.53 0 0 1 .532.53l.019 7.134a.53.53 0 0 1-.53.532Zm-291.506 43.606-23.855.063a.532.532 0 0 1-.533-.53l-.018-7.134a.53.53 0 0 1 .529-.533l23.856-.063c.293 0 .532.237.532.53l.019 7.134a.53.53 0 0 1-.53.533Zm68.812-.166-66.903.176a.348.348 0 0 1-.349-.347l-.02-7.5a.348.348 0 0 1 .347-.35l66.904-.176a.35.35 0 0 1 .349.348l.019 7.5a.348.348 0 0 1-.347.349Zm58.102.024-31.947.085a.334.334 0 0 1-.335-.334l-.02-7.528c0-.184.149-.334.333-.335l31.948-.084c.184 0 .334.149.335.333l.019 7.528a.333.333 0 0 1-.333.335Zm81.196-.213-74.273.195a.53.53 0 0 1-.532-.529l-.019-7.135a.53.53 0 0 1 .53-.532l74.273-.196c.293 0 .531.237.532.53l.019 7.134a.532.532 0 0 1-.53.533Zm-139.243 14.587-92.762.245a.348.348 0 0 1-.349-.348l-.02-7.5c0-.192.155-.348.347-.349l92.763-.244a.348.348 0 0 1 .349.347l.02 7.5a.348.348 0 0 1-.348.349Zm58.061.025-31.947.084a.335.335 0 0 1-.335-.333l-.02-7.529c0-.184.149-.334.333-.334l31.948-.085c.184 0 .334.149.335.334l.02 7.528a.334.334 0 0 1-.334.335Zm116.735-.307-92.86.244a.532.532 0 0 1-.533-.53l-.018-7.134a.53.53 0 0 1 .529-.532l92.861-.245a.531.531 0 0 1 .532.53l.019 7.134a.53.53 0 0 1-.53.533Zm-244.343 14.87-22.859.06a.53.53 0 0 1-.533-.53l-.019-7.134c0-.293.237-.532.53-.532l22.86-.06a.53.53 0 0 1 .532.529l.019 7.135a.531.531 0 0 1-.53.532Zm69.891-.169-66.903.176a.348.348 0 0 1-.35-.347l-.019-7.5a.348.348 0 0 1 .347-.349l66.904-.176a.348.348 0 0 1 .349.347l.019 7.5a.348.348 0 0 1-.347.349Zm58.017.025-31.947.084a.334.334 0 0 1-.335-.333l-.02-7.529c0-.184.149-.334.333-.334l31.948-.085c.184 0 .334.149.335.334l.019 7.528a.334.334 0 0 1-.333.335Zm164.082-.432-126.076.332a.531.531 0 0 1-.532-.53l-.019-7.134a.532.532 0 0 1 .53-.533l126.076-.332c.293 0 .532.237.532.53l.019 7.134a.53.53 0 0 1-.53.533Zm-292.085-56.608-22.86.061a.532.532 0 0 1-.532-.53l-.019-7.134c0-.294.237-.532.53-.533l22.859-.06a.532.532 0 0 1 .533.53l.019 7.134a.531.531 0 0 1-.53.532Zm69.621-.168-66.904.176a.348.348 0 0 1-.349-.347l-.02-7.5c0-.192.155-.349.348-.349l66.903-.176a.347.347 0 0 1 .349.347l.02 7.5a.347.347 0 0 1-.347.349Zm58.185.025-31.947.084a.335.335 0 0 1-.335-.333l-.02-7.529c0-.184.149-.334.333-.335l31.948-.084c.184 0 .334.149.335.334l.02 7.528a.335.335 0 0 1-.334.335Zm163.542-.431-126.076.332a.53.53 0 0 1-.533-.529l-.018-7.135a.53.53 0 0 1 .529-.532l126.077-.332a.53.53 0 0 1 .532.53l.019 7.134a.531.531 0 0 1-.53.532Zm-291.118 14.993-22.86.061a.532.532 0 0 1-.532-.53l-.019-7.134a.532.532 0 0 1 .53-.533l22.859-.06a.53.53 0 0 1 .533.53l.019 7.134a.531.531 0 0 1-.53.532Zm69.784-.168-66.904.176a.348.348 0 0 1-.349-.347l-.019-7.5a.347.347 0 0 1 .347-.349l66.903-.177a.35.35 0 0 1 .35.348l.019 7.5a.348.348 0 0 1-.347.349Zm58.092.025-31.947.084a.334.334 0 0 1-.335-.334l-.02-7.528c0-.184.149-.334.333-.335l31.948-.084c.184 0 .334.149.335.333l.019 7.529a.334.334 0 0 1-.333.335Zm163.948-.432-126.076.332a.53.53 0 0 1-.533-.53l-.018-7.134a.53.53 0 0 1 .529-.532l126.077-.332a.53.53 0 0 1 .532.529l.019 7.134a.532.532 0 0 1-.53.533Zm-207.753 52.841-2.619.007a.195.195 0 0 1-.195-.195l-.531-201.6c0-.108.087-.195.194-.195l2.619-.007a.195.195 0 0 1 .196.194l.53 201.6a.195.195 0 0 1-.194.196Z",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M305.677 406.402H124.593a2.93 2.93 0 1 0 0 5.862h181.084a2.932 2.932 0 1 0 0-5.862Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M280.028 376.599H150.242a7.085 7.085 0 0 0-7.085 7.085v22.718h143.956v-22.718a7.085 7.085 0 0 0-7.085-7.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M270.426 363.94H159.844a7.085 7.085 0 0 0-7.085 7.085v5.574h124.752v-5.574a7.085 7.085 0 0 0-7.085-7.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M248.446 363.94h-66.622v-35.557c0-.985.799-1.783 1.784-1.783h63.054c.985 0 1.784.798 1.784 1.783v35.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M106.494 219.772a4.081 4.081 0 0 0-.318 5.676l91.165 106.456a4.08 4.08 0 0 0 5.847.328l7.756-7.141-100.403-109.045-4.047 3.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M118.978 185.57a8.235 8.235 0 0 0-11.522-.357l-8.176 7.528a8.236 8.236 0 0 0-.594 11.512l108.777 124.043 22.802-20.995a4.474 4.474 0 0 0 .186-6.401L118.978 185.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m126.78 211.56-.855.788a6.517 6.517 0 0 0-.38 9.209l57.402 62.344a6.517 6.517 0 0 0 9.209.38l.855-.788a6.517 6.517 0 0 0 .38-9.209l-57.402-62.343a6.517 6.517 0 0 0-9.209-.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "m127.552 210.857-2.41 2.219 66.227 71.937 2.41-2.219-66.227-71.937Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M215.891 347.629c16.049 0 29.06-13.011 29.06-29.06 0-16.05-13.011-29.061-29.06-29.061-16.05 0-29.061 13.011-29.061 29.061 0 16.049 13.011 29.06 29.061 29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M231.583 334.264c8.669-8.669 8.669-22.724 0-31.393s-22.724-8.669-31.393 0-8.669 22.724 0 31.393 22.724 8.669 31.393 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m118.636 200.671 7.2 4.454a3.278 3.278 0 0 0 4.561-1.146l55.731-97.784a3.277 3.277 0 0 0-1.113-4.427l-3.757-2.324-62.622 101.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m179.012 74.662 7.59 4.695a6.614 6.614 0 0 1 2.215 8.988l-66.95 114.325-21.167-13.095a3.592 3.592 0 0 1-1.119-5.019L169.98 76.692a6.614 6.614 0 0 1 9.032-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m158.433 103.521-37.436 60.513a5.7 5.7 0 0 0 9.695 5.998l37.436-60.513a5.7 5.7 0 1 0-9.695-5.998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "m165.157 100.985-43.433 70.207 2.237 1.385 43.434-70.208-2.238-1.384Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M113.745 219.615c12.888 0 23.336-10.449 23.336-23.337s-10.448-23.336-23.336-23.336c-12.889 0-23.337 10.448-23.337 23.336 0 12.888 10.448 23.337 23.337 23.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M126.347 208.882c6.962-6.961 6.962-18.248 0-25.209-6.961-6.962-18.248-6.962-25.209 0-6.962 6.961-6.962 18.248 0 25.209 6.961 6.961 18.248 6.961 25.209 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m257.301 115.246-3.641 5.986c-1.468 2.414-4.124 3.498-5.976 2.44L179.34 85.048l10.153-16.692c.824-1.354 2.327-1.93 3.328-1.276l63.899 41.737c1.791 1.158 2.05 4.015.581 6.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M188.53 95.871c10.117 0 18.318-8.201 18.318-18.318s-8.201-18.318-18.318-18.318-18.319 8.201-18.319 18.318 8.202 18.318 18.319 18.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M202.467 78.735c.656-7.7-5.055-14.473-12.755-15.129-7.701-.655-14.474 5.056-15.129 12.756-.656 7.7 5.055 14.474 12.755 15.13 7.701.654 14.474-5.056 15.129-12.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m268.857 116.95 15.305-11.049 21.207 25.792-3.215 3.796-19.174-20.568-11.844 8.67-2.279-6.641Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M343.717 75.678a2.143 2.143 0 0 1 2.368-1.613c2.397.325 4.816.76 7.189 1.29a2.14 2.14 0 1 1-.934 4.18 81.754 81.754 0 0 0-6.83-1.225 2.142 2.142 0 0 1-1.793-2.632Zm18.095 4.553a2.142 2.142 0 0 1 2.83-1.502 86.562 86.562 0 0 1 6.725 2.837 2.142 2.142 0 0 1-1.831 3.873 81.995 81.995 0 0 0-6.391-2.696 2.142 2.142 0 0 1-1.333-2.512Zm16.642 8.424a2.142 2.142 0 0 1 3.258-1.282 85.354 85.354 0 0 1 5.926 4.268 2.142 2.142 0 0 1-2.651 3.365 81.24 81.24 0 0 0-5.627-4.054 2.143 2.143 0 0 1-.906-2.297Zm14.344 11.936a2.142 2.142 0 0 1 3.627-.972 86.24 86.24 0 0 1 4.824 5.486 2.143 2.143 0 0 1-3.336 2.689 80.86 80.86 0 0 0-4.582-5.211 2.144 2.144 0 0 1-.533-1.992Zm11.322 14.836a2.14 2.14 0 0 1 3.917-.595 86.648 86.648 0 0 1 3.487 6.415 2.14 2.14 0 1 1-3.846 1.885 82.574 82.574 0 0 0-3.314-6.097 2.131 2.131 0 0 1-.244-1.608Zm7.757 16.969a2.143 2.143 0 0 1 4.117-.163 86.296 86.296 0 0 1 1.981 7.028 2.142 2.142 0 0 1-4.169.985 82.454 82.454 0 0 0-1.882-6.677 2.128 2.128 0 0 1-.047-1.173Zm-13.633 77.458a2.12 2.12 0 0 1 .396-.814 80.955 80.955 0 0 0 4.046-5.637 2.141 2.141 0 1 1 3.584 2.346 85.455 85.455 0 0 1-4.26 5.936 2.141 2.141 0 0 1-3.766-1.831Zm17.435-59.204a2.142 2.142 0 0 1 4.214.308c.225 2.414.348 4.868.365 7.292a2.146 2.146 0 0 1-2.127 2.157 2.143 2.143 0 0 1-2.157-2.127 80.846 80.846 0 0 0-.346-6.924 2.153 2.153 0 0 1 .051-.706Zm-7.641 43.323c.033-.137.08-.274.143-.406a81.73 81.73 0 0 0 2.685-6.4 2.142 2.142 0 0 1 4.017 1.488 86.963 86.963 0 0 1-2.825 6.735 2.142 2.142 0 0 1-4.02-1.417Zm7.269-24.677a2.143 2.143 0 0 1 4.204.793 85.798 85.798 0 0 1-1.276 7.19 2.141 2.141 0 1 1-4.181-.927 81.418 81.418 0 0 0 1.21-6.83c.011-.077.025-.153.043-.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M387.924 220.794c.1-.41.321-.795.661-1.095a84.176 84.176 0 0 0 2.456-2.262 2.141 2.141 0 1 1 2.965 3.091 86.158 86.158 0 0 1-2.583 2.379 2.141 2.141 0 0 1-3.499-2.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M326 241.512a2.141 2.141 0 0 1 2.252-1.625c1.1.088 2.221.155 3.331.199a2.141 2.141 0 1 1-.167 4.28 86.761 86.761 0 0 1-3.508-.209 2.142 2.142 0 0 1-1.908-2.645Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M251.558 138.684c.234-.958.484-1.915.752-2.871a2.143 2.143 0 0 1 4.126 1.154 83.248 83.248 0 0 0-1.57 6.646 2.141 2.141 0 1 1-4.206-.809c.263-1.368.565-2.754.898-4.12Zm4.535-13.527c.029-.117.067-.232.117-.346a85.437 85.437 0 0 1 3.128-6.471 2.14 2.14 0 1 1 3.774 2.024 82.427 82.427 0 0 0-2.972 6.148 2.142 2.142 0 0 1-4.047-1.355Zm-6.79 28.836a2.142 2.142 0 0 1 4.219.623 80.437 80.437 0 0 0-.072 6.824 2.141 2.141 0 1 1-4.282.135 85.22 85.22 0 0 1 .076-7.186c.008-.136.028-.268.059-.396Zm15.896-44.786c.064-.264.181-.52.351-.753a85.326 85.326 0 0 1 4.475-5.625 2.143 2.143 0 0 1 3.236 2.807 81.278 81.278 0 0 0-4.25 5.341 2.141 2.141 0 0 1-3.812-1.77Zm-14.833 63.106a2.142 2.142 0 0 1 4.193.146c.38 2.23.861 4.475 1.429 6.672a2.141 2.141 0 1 1-4.147 1.073 85.751 85.751 0 0 1-1.505-7.025 2.148 2.148 0 0 1 .03-.866Zm5.057 17.643a2.142 2.142 0 0 1 4.063-.307 82.358 82.358 0 0 0 2.851 6.203 2.143 2.143 0 0 1-3.814 1.95 86.292 86.292 0 0 1-3-6.528 2.129 2.129 0 0 1-.1-1.318Zm8.783 16.121a2.142 2.142 0 0 1 3.838-.717 81.65 81.65 0 0 0 4.134 5.435 2.14 2.14 0 1 1-3.298 2.733 85.992 85.992 0 0 1-4.351-5.719 2.14 2.14 0 0 1-.323-1.732Zm12.089 13.821a2.14 2.14 0 0 1 3.527-1.07 81.24 81.24 0 0 0 5.223 4.395 2.142 2.142 0 0 1-2.616 3.391 85.071 85.071 0 0 1-5.5-4.628 2.14 2.14 0 0 1-.634-2.088Zm14.834 10.834a2.14 2.14 0 0 1 3.145-1.353 80.888 80.888 0 0 0 6.061 3.134 2.143 2.143 0 0 1-1.807 3.885 85.647 85.647 0 0 1-6.38-3.3 2.144 2.144 0 0 1-1.019-2.366Zm16.84 7.305c.01-.043.023-.085.036-.128a2.141 2.141 0 0 1 2.678-1.413 82.493 82.493 0 0 0 6.602 1.747 2.141 2.141 0 0 1 1.63 2.553c-.236 1.175-1.398 1.885-2.553 1.63a86.367 86.367 0 0 1-6.945-1.838 2.142 2.142 0 0 1-1.448-2.551Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M277.633 95.621c.101-.414.325-.8.669-1.103a86.681 86.681 0 0 1 2.69-2.258 2.142 2.142 0 0 1 2.687 3.337 81.213 81.213 0 0 0-2.555 2.144 2.141 2.141 0 0 1-3.491-2.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M301.084 104.313a1.002 1.002 0 0 0-.564 1.016l1.378 12.106a53.07 53.07 0 0 0-11.507 12.777l-12.175-.097a1 1 0 0 0-.952.667l-4.874 13.777a1 1 0 0 0 .32 1.117l9.528 7.581a53.073 53.073 0 0 0 .91 17.171l-8.684 8.546a1 1 0 0 0-.201 1.144l6.296 13.189a.998.998 0 0 0 1.016.563l12.105-1.377A53.094 53.094 0 0 0 306.458 204l-.097 12.175a1 1 0 0 0 .667.952l13.777 4.874a1 1 0 0 0 1.117-.32l7.581-9.528c5.82.643 11.612.305 17.171-.911l8.546 8.684a1 1 0 0 0 1.144.201l13.189-6.295c.385-.184.611-.592.563-1.016l-1.377-12.106a53.067 53.067 0 0 0 11.506-12.777l12.175.097a1 1 0 0 0 .952-.667l4.875-13.777a1.002 1.002 0 0 0-.321-1.117l-9.527-7.581a53.073 53.073 0 0 0-.911-17.171l8.684-8.546a1 1 0 0 0 .201-1.144l-6.295-13.189a1.002 1.002 0 0 0-1.017-.563l-12.105 1.377a53.065 53.065 0 0 0-12.777-11.506l.097-12.176a1.001 1.001 0 0 0-.667-.951l-13.777-4.875a1.002 1.002 0 0 0-1.118.32l-7.581 9.528a53.067 53.067 0 0 0-17.17.911l-8.546-8.684a1.001 1.001 0 0 0-1.145-.201l-13.188 6.295Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M321.048 155.584c1.696-6.957 8.294-11.821 15.631-11.138 8.066.751 14.016 7.922 13.266 15.987a14.59 14.59 0 0 1-5.246 9.944 14.59 14.59 0 0 1-10.741 3.322c-8.066-.751-14.016-7.923-13.266-15.988.068-.727.188-1.438.356-2.127Zm25.209 6.179c.131-.537.224-1.086.276-1.647.576-6.183-3.988-11.682-10.171-12.258-6.184-.575-11.685 3.985-12.258 10.171-.576 6.183 3.988 11.682 10.17 12.258a11.189 11.189 0 0 0 8.236-2.547 11.18 11.18 0 0 0 3.747-5.977Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M300.363 150.851a37.283 37.283 0 0 1 1.471-4.661 36.16 36.16 0 0 1 2.525-5.204l.039-.068.115-.192.226-.371a.858.858 0 0 1 1.179-.28.858.858 0 0 1 .279 1.179 34.607 34.607 0 0 0-3.158 6.611c-4.068 11.493-1.638 23.734 5.364 32.696a34.199 34.199 0 0 0 15.596 11.216c1.121.397 2.254.734 3.394 1.011 7.67 1.869 15.682 1.05 22.903-2.397 8.294-3.958 14.55-10.91 17.615-19.574 6.329-17.894-3.076-37.585-20.96-43.912a34.644 34.644 0 0 0-3.35-.998 34.292 34.292 0 0 0-14.932-.298.857.857 0 1 1-.34-1.68 36.026 36.026 0 0 1 15.677.313c1.185.289 2.359.638 3.516 1.047 18.777 6.644 28.645 27.329 22.005 46.1-3.218 9.095-9.786 16.393-18.493 20.549-7.58 3.618-15.992 4.478-24.044 2.516a36.627 36.627 0 0 1-3.562-1.061c-9.096-3.219-16.394-9.786-20.55-18.493-3.619-7.582-4.478-15.996-2.515-24.049Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m265.763 110.733-6.668-4.021a.308.308 0 0 0-.423.105l-12.098 20.062a.307.307 0 0 0 .105.422l6.668 4.022a.309.309 0 0 0 .423-.105l12.098-20.062a.308.308 0 0 0-.105-.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m264.867 135.208-2.358 18.728 32.802 6.244 1.79-4.642-27.242-6.964 1.929-14.551-6.921 1.185Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M259.926 134.72a11.85 11.85 0 0 0 11.635 1.953c6.139-2.273 9.273-9.091 7-15.23a11.82 11.82 0 0 0-6.265-6.7l-12.37 19.977Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m253.191 130.562-1.936 3.211c-.349.579-.129 1.352.49 1.725l5.953 3.59c.62.374 1.405.207 1.755-.372l15.437-25.599c.349-.579.129-1.351-.49-1.725l-5.953-3.59c-.62-.373-1.406-.207-1.755.372l-1.774 2.942-11.727 19.446Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M353.759 221.886a1.22 1.22 0 0 1 1.077-1.224 48.955 48.955 0 0 1 4.147-.305 1.22 1.22 0 0 1 1.257 1.181v.023a1.218 1.218 0 0 1-1.181 1.233c-1.315.041-2.64.138-3.94.29a1.22 1.22 0 0 1-1.36-1.198Zm10.621-.047a1.22 1.22 0 0 1 1.349-1.229c1.375.147 2.758.353 4.109.615a1.219 1.219 0 1 1-.462 2.394 46.361 46.361 0 0 0-3.906-.583 1.222 1.222 0 0 1-1.09-1.197Zm10.368 2.293a1.22 1.22 0 0 1 1.615-1.168c1.306.447 2.609.957 3.872 1.516a1.22 1.22 0 0 1-.987 2.23 46.497 46.497 0 0 0-3.676-1.44 1.218 1.218 0 0 1-.824-1.138Zm9.597 4.554a1.22 1.22 0 0 1 1.863-1.049 48.92 48.92 0 0 1 3.435 2.344 1.22 1.22 0 0 1-1.459 1.953 46.183 46.183 0 0 0-3.263-2.225 1.221 1.221 0 0 1-.576-1.023Zm8.34 6.58a1.218 1.218 0 0 1 2.076-.881c.98.968 1.933 1.993 2.83 3.044a1.22 1.22 0 0 1-1.855 1.584c-.853-1-1.758-1.974-2.689-2.894a1.22 1.22 0 0 1-.362-.853Zm6.677 8.261a1.218 1.218 0 0 1 2.246-.672 48.891 48.891 0 0 1 2.086 3.595 1.22 1.22 0 0 1-2.159 1.133 47.013 47.013 0 0 0-1.982-3.416 1.208 1.208 0 0 1-.191-.64Zm3.431 44.639c-.002-.168.031-.34.103-.505a45.541 45.541 0 0 0 1.434-3.679 1.22 1.22 0 0 1 2.308.786 48.785 48.785 0 0 1-1.509 3.876 1.221 1.221 0 0 1-2.336-.478Zm1.245-35.111a1.22 1.22 0 0 1 2.367-.425c.466 1.299.88 2.634 1.232 3.969a1.22 1.22 0 1 1-2.357.622 45.992 45.992 0 0 0-1.17-3.769 1.229 1.229 0 0 1-.072-.397Zm1.911 24.97a1.264 1.264 0 0 1 .021-.244c.247-1.288.44-2.603.576-3.909a1.22 1.22 0 0 1 2.426.253 49.755 49.755 0 0 1-.606 4.113 1.22 1.22 0 0 1-2.417-.213Zm.52-14.635a1.22 1.22 0 0 1 2.43-.157 48.599 48.599 0 0 1 .314 4.171 1.22 1.22 0 0 1-2.438.054 46.229 46.229 0 0 0-.298-3.938 1.44 1.44 0 0 1-.008-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M398.649 295.658c-.003-.24.065-.484.21-.698.353-.52.7-1.056 1.034-1.594a1.22 1.22 0 0 1 2.072 1.286 49.578 49.578 0 0 1-1.088 1.677 1.219 1.219 0 0 1-2.228-.671Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M367.431 315.836a1.22 1.22 0 0 1 1.012-1.215 46.779 46.779 0 0 0 1.865-.361 1.22 1.22 0 1 1 .513 2.384c-.651.14-1.312.268-1.964.38a1.22 1.22 0 0 1-1.426-1.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M311.846 269.656c-.006-.56-.004-1.124.009-1.689a1.219 1.219 0 1 1 2.438.053 47.344 47.344 0 0 0 .074 3.887 1.219 1.219 0 1 1-2.434.148 50.112 50.112 0 0 1-.087-2.399Zm.589-8.1a1.216 1.216 0 0 1 .015-.207c.213-1.344.486-2.693.81-4.011a1.22 1.22 0 0 1 2.368.583 46.732 46.732 0 0 0-.77 3.811 1.219 1.219 0 0 1-2.423-.176Zm.332 16.861a1.218 1.218 0 0 1 2.414-.252c.253 1.263.564 2.532.925 3.772a1.219 1.219 0 1 1-2.342.68 48.739 48.739 0 0 1-.974-3.973 1.257 1.257 0 0 1-.023-.227Zm2.434-26.943a1.228 1.228 0 0 1 .087-.465 48.745 48.745 0 0 1 1.673-3.734 1.219 1.219 0 1 1 2.181 1.09 46.293 46.293 0 0 0-1.588 3.546 1.22 1.22 0 0 1-2.353-.437Zm.741 36.895a1.22 1.22 0 0 1 2.333-.512 46.29 46.29 0 0 0 1.731 3.477 1.219 1.219 0 1 1-2.135 1.178 48.706 48.706 0 0 1-1.822-3.661 1.22 1.22 0 0 1-.107-.482Zm5.283 9.014a1.22 1.22 0 0 1 2.197-.744 46.675 46.675 0 0 0 2.449 3.018 1.219 1.219 0 1 1-1.828 1.614 49.722 49.722 0 0 1-2.577-3.175 1.22 1.22 0 0 1-.241-.713Zm7.122 7.648a1.22 1.22 0 0 1 2.015-.938 46.425 46.425 0 0 0 3.048 2.413 1.218 1.218 0 0 1-1.432 1.973 49.48 49.48 0 0 1-3.208-2.538 1.216 1.216 0 0 1-.423-.91Zm8.62 5.912a1.219 1.219 0 0 1 1.793-1.089 46.522 46.522 0 0 0 3.502 1.686 1.22 1.22 0 0 1-.963 2.24 48.778 48.778 0 0 1-3.688-1.775 1.219 1.219 0 0 1-.644-1.062Zm9.711 3.877a1.22 1.22 0 0 1 1.543-1.19 46.42 46.42 0 0 0 3.785.872 1.22 1.22 0 0 1-.447 2.397 48.726 48.726 0 0 1-3.985-.918 1.22 1.22 0 0 1-.896-1.161Zm10.319 1.648a1.22 1.22 0 0 1 1.279-1.233 46.247 46.247 0 0 0 3.887.03 1.22 1.22 0 0 1 1.26 1.178c.036.681-.505 1.236-1.177 1.259a48.59 48.59 0 0 1-4.09-.031 1.22 1.22 0 0 1-1.159-1.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M320.137 242.225a1.214 1.214 0 0 1 .213-.703 49.44 49.44 0 0 1 1.165-1.625 1.218 1.218 0 1 1 1.953 1.46c-.38.507-.752 1.027-1.106 1.544a1.22 1.22 0 0 1-2.225-.676Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M334.297 243.703a.569.569 0 0 0-.167.64l2.471 6.48a30.217 30.217 0 0 0-4.539 8.673l-6.728 1.667a.569.569 0 0 0-.43.502l-.741 8.287a.57.57 0 0 0 .335.57l6.325 2.834a30.223 30.223 0 0 0 2.93 9.339l-3.581 5.941a.57.57 0 0 0 .051.659l5.336 6.383a.571.571 0 0 0 .64.167l6.48-2.471a30.217 30.217 0 0 0 8.673 4.539l1.667 6.727c.059.236.26.409.503.431l8.286.74a.567.567 0 0 0 .57-.334l2.834-6.326a30.209 30.209 0 0 0 9.34-2.929l5.94 3.58a.57.57 0 0 0 .659-.05l6.383-5.336a.57.57 0 0 0 .167-.64l-2.471-6.481a30.199 30.199 0 0 0 4.539-8.672l6.727-1.667a.572.572 0 0 0 .431-.503l.74-8.286a.57.57 0 0 0-.334-.571l-6.326-2.833a30.192 30.192 0 0 0-2.929-9.34l3.58-5.94a.57.57 0 0 0-.05-.66l-5.336-6.382a.568.568 0 0 0-.64-.167l-6.481 2.47a30.196 30.196 0 0 0-8.672-4.538l-1.667-6.728a.57.57 0 0 0-.503-.43l-8.286-.741a.572.572 0 0 0-.571.335l-2.833 6.325a30.227 30.227 0 0 0-9.34 2.929l-5.94-3.58a.571.571 0 0 0-.66.051l-6.382 5.336Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M352.553 269.153c-.048-4.076 2.903-7.691 7.045-8.352 4.554-.726 8.849 2.388 9.575 6.941a8.301 8.301 0 0 1-1.487 6.225 8.309 8.309 0 0 1-5.453 3.35c-4.554.726-8.849-2.388-9.575-6.941-.066-.41-.1-.819-.105-1.223Zm14.775-.156a6.418 6.418 0 0 0-7.422-6.269c-3.491.557-5.88 3.849-5.322 7.341a6.42 6.42 0 0 0 7.341 5.322 6.369 6.369 0 0 0 4.182-2.569 6.364 6.364 0 0 0 1.221-3.825Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M340.479 269.467a20.787 20.787 0 0 1 .808-6.005l.013-.043a9.205 9.205 0 0 1 .108-.358.488.488 0 1 1 .931.289 19.651 19.651 0 0 0-.807 4.092c-.619 6.913 2.452 13.319 7.58 17.271a19.453 19.453 0 0 0 10.185 3.98c.674.061 1.347.087 2.014.078 4.494-.053 8.797-1.638 12.291-4.559a19.453 19.453 0 0 0 6.946-13.284c.961-10.761-7.008-20.29-17.765-21.251a19.54 19.54 0 0 0-10.264 1.869.485.485 0 0 1-.651-.226.488.488 0 0 1 .226-.652 20.51 20.51 0 0 1 10.776-1.963c11.293 1.009 19.659 11.021 18.65 22.31a20.424 20.424 0 0 1-7.293 13.945c-3.668 3.067-8.185 4.73-12.902 4.787a21.11 21.11 0 0 1-2.114-.082 20.43 20.43 0 0 1-13.946-7.292c-3.068-3.669-4.731-8.188-4.786-12.906Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "m374.401 302.349-.377-3.259c7.635-1.209 13.017-5.777 15.297-7.09 2.367 3.062 3.988 5.838 5.727 9.476-9.472 4.145-20.647.873-20.647.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M463.466 402.233s1.413 2.227 1.769 8.462a1.016 1.016 0 0 1-1.009 1.075h-11.049a.651.651 0 0 1-.619-.857c.647-1.916 2.605-6.588 6.973-9.257l3.935.577Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "m463.947 398.009-.625 5.24a.986.986 0 0 1-.861.866c-.604.069-1.482.118-2.336-.022-.776-.128-1.334-.819-1.334-1.606v-5.059l5.156.581Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M436.131 401.656s2.114 3.287 2.069 7.798c-.011 1.063-.9 1.91-1.963 1.91h-17.159c-.804 0-1.13-1.033-.473-1.495 3.247-2.28 9.63-6.539 14.245-8.213h3.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m437.898 395.997-1.333 6.471c-.149.724-.857 1.211-1.578 1.05a4.843 4.843 0 0 1-1.509-.631 1.534 1.534 0 0 1-.684-1.564l1.379-7.84 3.725 2.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M461.498 306.023s4.635 4.086 5.507 9.002c.872 4.916-2.471 84.814-2.471 84.814s-4.635.771-7.024-.676c0 0-2.833-51.854-4.987-63.836 0 0-11.295 53.714-14.424 63.419 0 0-4.465.543-5.905-.306 0 0 2.959-69.628 6.677-82.007l22.627-10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M452.659 333.642c.224 0 .428-.15.486-.376l1.919-7.362 4.087-2.622a.503.503 0 1 0-.543-.847l-4.253 2.729a.504.504 0 0 0-.215.296l-1.968 7.552a.501.501 0 0 0 .487.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M415.764 259.856c19.51-1.619 24.609 2.418 24.609 2.418l-9.376 14.801s-19.17-.378-32.906-10.965c2.571-2.769 4.356-5.829 5.501-8.211 3.542 1.472 7.621 2.335 12.172 1.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M385.212 231.219c.026-.625.873-.795 1.139-.229l2.489 5.312a5.524 5.524 0 0 1 .442 3.293l-.873 3.092a5.337 5.337 0 0 0 1.089 4.248c2.287 2.86 7.159 8.082 14.094 10.964-1.145 2.382-2.931 5.442-5.501 8.211-5.041-3.885-9.35-9.142-11.711-16.262a2.61 2.61 0 0 1-1.842-2.595l.674-16.034Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M409.342 268.438c6.868-7.401 19.95-10.745 27.525-12.118a6.948 6.948 0 0 1 7.765 4.405c3.408 9.163 12.679 33.001 14.475 37.098a317.93 317.93 0 0 0 3.992 8.697 2.465 2.465 0 0 1-1.15 3.283c-6.373 3.071-17.839 6.546-22.488 7.902a1.595 1.595 0 0 1-2.041-1.534c0-.904-.245-1.79-.71-2.565l-17.606-29.339c-10.974 12.168-17.715 17.053-25.04 17.775-2.417-2.462-6.389-7.67-5.089-10.144 9.381-4.91 20.367-23.46 20.367-23.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "m377.134 301.92-7.749 7.943-11.332 2.887c.432-1.675 7.737-6.015 7.737-6.015s5.385-6.911 7.085-8.526c1.411-1.342 3.136.881 3.68 1.673.111.162.173.264.173.264l.406 1.774Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "m426.448 242.728 5.851 14.276s-6.722 4.653-12.131 4.211l-2.919-12.838 9.199-5.649Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M416.566 232.995c-.134.19-4.233 14.997-4.233 14.997l8.504 2.16 5.97-13.456s-7.998-6.879-10.241-3.701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "m423.604 238.74-2.587 7.33a1.066 1.066 0 0 1-.135.262c-.351.499-1.685 2.127-3.268.661-1.436-1.331-2.766-2.524-3.994-2.74a1.083 1.083 0 0 0-1.235.779c-.372 1.345-1.155 4.392-1.43 7.143a1.083 1.083 0 0 0 .88 1.168c1.661.315 5.183.882 8.123.675.398-.028.749-.267.915-.63.81-1.771 3.292-7.142 4.216-8.532.866-1.305 2.991-1.268 3.882-1.189.292.026.579-.068.799-.262.78-.683 2.263-2.427.176-4.515a1.089 1.089 0 0 1 .026-1.566c.896-.842 1.854-2.336.361-4.19-1.517-1.884-3.521-1.584-4.748-1.136a1.087 1.087 0 0 1-1.307-.483c-.154-.258-.422-.454-.886-.414-.626.054-1.152-.468-1.141-1.096.022-1.207-.411-2.732-2.504-3.384-3.715-1.156-6.031 2.433-6.261 5.111-.229 2.678 3.87 3.703 6.28 3.522 1.832-.137 3.193 1.679 3.74 2.557.173.279.208.62.098.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M424.12 247.515s.6-4.649 2.534-4.876c1.934-.228 3.816 1.361 1.893 3.971-2.391 3.246-4.427.905-4.427.905Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 155.905,
    x2: 209.847,
    y1: 184.7,
    y2: 184.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 101.888,
    x2: 167.007,
    y1: 162.904,
    y2: 162.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 216.532,
    x2: 215.86,
    y1: 387.678,
    y2: 398.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 216.796,
    x2: 214.443,
    y1: 358.904,
    y2: 409.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 216.492,
    x2: 214.475,
    y1: 345.019,
    y2: 387.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 217.406,
    x2: 214.376,
    y1: 315.101,
    y2: 356.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 149.984,
    x2: 160.743,
    y1: 280.475,
    y2: 270.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 148.872,
    x2: 174.965,
    y1: 264.662,
    y2: 240.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 129.911,
    x2: 170.54,
    y1: 180.678,
    y2: 273.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 194.512,
    x2: 237.269,
    y1: 338.253,
    y2: 298.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 172.912,
    x2: 151.031,
    y1: 168.809,
    y2: 150.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 109.755,
    x2: 182.839,
    y1: 195.178,
    y2: 77.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 123.846,
    x2: 160.998,
    y1: 118.493,
    y2: 151.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 101.468,
    x2: 126.021,
    y1: 216.125,
    y2: 176.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 185.149,
    x2: 255.464,
    y1: 75.497,
    y2: 118.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 225.295,
    x2: 144.679,
    y1: 69.602,
    y2: 87.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 327.008,
    x2: 285.084,
    y1: 145.589,
    y2: 119.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -1525.19,
    x2: -1392.25,
    y1: -347.334,
    y2: -312.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -1542.79,
    x2: -1409.84,
    y1: -279.438,
    y2: -245.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -1551.94,
    x2: -1419,
    y1: -243.944,
    y2: -209.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -1537.22,
    x2: -1404.28,
    y1: -300.767,
    y2: -266.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -1519.39,
    x2: -1386.44,
    y1: -370.03,
    y2: -335.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -1531.48,
    x2: -1398.54,
    y1: -323.136,
    y2: -288.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 352.802,
    x2: 306.565,
    y1: 180.119,
    y2: 150.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 315.933,
    x2: 274.01,
    y1: 174.465,
    y2: 148.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 266.025,
    x2: 277.573,
    y1: 124.693,
    y2: 131.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 276.856,
    x2: 244.28,
    y1: 118.887,
    y2: 129.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: -1014.72,
    x2: -958.52,
    y1: 2697.64,
    y2: 2599.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: -981.88,
    x2: -925.675,
    y1: 2716.51,
    y2: 2618.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: -996.151,
    x2: -939.945,
    y1: 2708.42,
    y2: 2609.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: -1032.73,
    x2: -976.529,
    y1: 2687.36,
    y2: 2588.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: -1064.05,
    x2: -1007.85,
    y1: 2669.61,
    y2: 2571.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: -1022.76,
    x2: -966.55,
    y1: 2693.2,
    y2: 2594.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 343.599,
    x2: 408.724,
    y1: 292.112,
    y2: 300.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 465.236,
    x2: 452.523,
    y1: 406.713,
    y2: 406.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 463.947,
    x2: 458.791,
    y1: 400.805,
    y2: 400.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 438.201,
    x2: 418.254,
    y1: 406.51,
    y2: 406.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 437.898,
    x2: 432.771,
    y1: 398.516,
    y2: 398.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 524.866,
    x2: 490.073,
    y1: 271.13,
    y2: 312.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 461.856,
    x2: 452.688,
    y1: 260.576,
    y2: 362.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 409.244,
    x2: 419.675,
    y1: 208.964,
    y2: 266.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 403.592,
    x2: 384.536,
    y1: 248.377,
    y2: 248.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 428.942,
    x2: 419.538,
    y1: 265.938,
    y2: 376.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 343.979,
    x2: 409.102,
    y1: 302.278,
    y2: 311.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 406.765,
    x2: 446.643,
    y1: 221.574,
    y2: 294.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 419.333,
    x2: 420.286,
    y1: 235.073,
    y2: 264.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 427.086,
    x2: 409.886,
    y1: 247.43,
    y2: 235.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 429.773,
    x2: 426.588,
    y1: 265.044,
    y2: 245.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.694 24h382.611v388H82.694z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSlider3);
export default __webpack_public_path__ + "static/media/login-slider-3.bf77732d7f388348dcb71ec55c0fda6a.svg";
export { ForwardRef as ReactComponent };